import {
  loadGoogleMaps,
  initializeMap,
  addMapMarkers
} from "../../Google/Maps/google-maps";

const mapContainer = document.getElementById("clinic-map");

if (!mapContainer) {
  throw 'Map initialization failed: Container with ID "clinic-map" not found';
}

const googleMapsApiKey = mapContainer.dataset.apiKey;

const googleMapsLanguage = mapContainer.dataset.language;

if (!googleMapsApiKey) {
  throw "Map initialization failed: ApiKey missing";
}

if (!googleMapsLanguage) {
  throw "Map initialization failed: Language missing";
}

const pinLatitude = parseFloat(mapContainer.dataset.pinLatitude ?? "0.0");

const pinLongitude = parseFloat(mapContainer.dataset.pinLongitude ?? "0.0");

const defaultZoom = mapContainer.dataset.defaultZoom
  ? parseInt(mapContainer.dataset.defaultZoom)
  : 0;

const initialize = async () => {
  await loadGoogleMaps(googleMapsApiKey, googleMapsLanguage);

  // HACK: For some reason, even when waiting for the Google Maps API to finish loading,
  // it takes some time before the "google" namespace is available and we can actually call
  // initializeMap.
  setTimeout(async () => {
    await initializeMap(
      mapContainer,
      mapContainer.id,
      pinLatitude,
      pinLongitude,
      defaultZoom
    );

    const clinicMarker: google.maps.marker.AdvancedMarkerElementOptions = {
      position: {
        lat: pinLatitude,
        lng: pinLongitude
      }
    };

    await addMapMarkers(mapContainer.id, [clinicMarker], false);
  }, 1000);
};

initialize();
